import { TOGGLE_UPLOAD_VERSION_MODAL } from '../../constants/ActionTypes';

export const toggleUploadVersionModal = (file = '') => {
  return {
    type: TOGGLE_UPLOAD_VERSION_MODAL,
    payload: file,
  };
};
